import { of, race } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap, flatMap, take, catchError } from 'rxjs/operators';
import {
  sendContactRequestRequest,
  sendContactRequestFulfilled,
  sendContactRequestRejected,
  sendContactRequestCancelled,
} from 'modules/Contact/actions-rxjs/sendContactRequest';

const sendContactRequestEpic = action$ =>
  action$.pipe(
    ofType('SEND_CONTACT_REQUEST'),
    mergeMap(action =>
      race(
        sendContactRequestRequest(action.payload, action).pipe(
          flatMap(response => of(sendContactRequestFulfilled(response.response, action.extras))),
          catchError(error => of(sendContactRequestRejected(error, action.extras))),
        ),
        action$.pipe(
          ofType('SEND_CONTACT_REQUEST'),
          flatMap(() => of(sendContactRequestCancelled(action.payload, action.extras))),
          take(1),
        ),
      )),
  );

export default sendContactRequestEpic;
